import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';

import { HttpMockManagerService } from './http-mock-manager.service';

export function httpMockInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const mockManager = inject(HttpMockManagerService);

  const mockedData = mockManager.get(req);

  if (mockedData instanceof HttpErrorResponse) {
    return throwError(() => mockedData);
  }

  if (mockedData) {
    return of(new HttpResponse({ status: 200, body: mockedData }));
  }

  return next(req);
}
